import { render, staticRenderFns } from "./BlogEditForm.vue?vue&type=template&id=73efbb83&scoped=true"
import script from "./BlogEditForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogEditForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BlogEditForm.vue?vue&type=style&index=0&id=73efbb83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73efbb83",
  null
  
)

export default component.exports